<!-- src/app/faq/faq.component.html -->

<section class="section faq mb-30">
  <div class="w-layout-blockcontainer mt-20 w-container">
    <h1 class="heading-18">FAQs</h1>
    <mat-accordion>
      @for (faq of faqs; track $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ faq.question }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        @for (answer of faq.answer; track $index) { @if (answer.type === 'p') {
        <p>
          {{ answer.text }}
        </p>
        } @if (answer.type === 'ul') {
        <ul>
          @for (lineItem of answer.text; track $index) {
          <li>
            {{ lineItem }}
          </li>
          }
        </ul>
        } }
      </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</section>
